export default __webpack_public_path__ + "f8c93ccff3d56e908798aa120cc2fa56.svg";